/**
 * Opens an external URL in a new tab
 * @param url - The URL to open
 */
export const openExternalLink = (url: string): void => {
  window.open(url, "_blank");
};
